import { Component, HostListener, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    imports: [MatIcon]
})
export class HelpComponent implements OnInit {
  @HostListener('document:keyup', ['$event'])
  KeyUpEvent(event: KeyboardEvent) {
    if(event.keyCode == 27) { //Keycode = ESC
      if(document.getElementsByClassName("helpMenuToggle").length > 0){
        const helpMenuToggle  = document.getElementsByClassName("helpMenuToggle")[0] as HTMLElement;
        helpMenuToggle.focus();
      }
    }
  }
  constructor() { }

  ngOnInit() {
  }

  stopPropagation(event){
    event.stopPropagation();
  }

  setFocus() {
    setTimeout(function(){
      const element = document.getElementById("pendo-resource-center-main-module-container");
      if(element) {
        element.focus();
      }
    }, 500);
  }

}
